import * as React from "react";
import {IMenuOption} from "./author-menu";
import {CustomHomeIcon} from "../new-icons/custom-home-icon";
import {CustomBookListIcon} from "../new-icons/custom-book-list-icon";
import {CustomApplicationListIcon} from "../new-icons/custom-application-list-icon";
import {CustomApplication2ListIcon} from "../new-icons/custom-application2-list-icon";
import {CustomMarketListIcon} from "../new-icons/custom-market-list-icon";
import {CustomPersonIcon} from "../new-icons/custom-person-icon";

export const PublisherMenu: IMenuOption[] = [
    {
        link: '/dashboard',
        icon: () => <CustomHomeIcon/>,
        label: 'menu.home',
        permission: '',
        matchUrl: ['/dashboard']
    },
    {//tutaj sa 2 mozliwe linki
        link: '/publisher/profile',
        icon: () => <CustomPersonIcon style={{color: '#CDBDDB'}}/>,
        label: 'menu.profile',
        permission: '',
        matchUrl: ['/publisher/profile', '/publisher/edit-profile', '/publisher/edit-profile-data']
    },
    {
        link: '/publisher/my-books/list',
        icon: () => <CustomBookListIcon/>,
        label: 'menu.myBooks',
        permission: '',
        matchUrl: ['/publisher/my-books/list', '/publisher/my-books/create', '/publisher/my-books/edit', '/publisher/my-books/details']
    },
    {
        link: '/publisher/manuscripts',
        icon: () => <CustomApplication2ListIcon/>,
        label: 'menu.publishProposals',
        permission: '',
        matchUrl: ['/publisher/manuscripts', '/publisher/manuscript']
    },
    {
        link: '/publisher/books-propositions',
        icon: () => <CustomApplicationListIcon/>,
        label: 'menu.booksProposals',
        permission: '',
        matchUrl: ['/publisher/books-propositions', '/publisher/book-proposition/']
    },
    {
        link: '/publisher/market',
        icon: () => <CustomMarketListIcon/>,
        label: 'menu.market',
        permission: 'market',
        matchUrl: ['/publisher/market']
    },
    {
        link: '/publisher/book-market',
        icon: () => <CustomMarketListIcon/>,
        label: 'menu.bookMarket',
        permission: 'market',
        matchUrl: ['/publisher/book-market']
    },
    {
        link: '/publisher/similar-books/list',
        icon: () => <CustomBookListIcon/>,
        label: 'menu.findSimilar',
        permission: 'similar_books',
        matchUrl: ['/publisher/similar-books/list', '/publisher/similar-books/edit', '/publisher/similar-books/add', '/publisher/similar-books/details']
    },
]